import DefaultAppIcon from '@/components/DefaultAppIcon';
import ColorTags from '@/components/ColorTags';
import { getMiniAppStatus } from '@/utils/status.tsx';
import $i18n from '@/i18n';
export const statusFilters = [
  {
    label: $i18n.get({
      id: 'aopf.pages.getMiniAppStatus.released',
      dm: '已发布',
    }),
    value: 'ONLINE,OFFLINE',
  },
  {
    label: $i18n.get({
      id: 'aopf.pages.getMiniAppStatus.disabled',
      dm: '已禁止',
    }),
    value: 'BLOCKED',
  },
];

export const renderTargetApp = (value, _i, record) => {
  return (
    <div style={{ display: 'flex' }}>
      <img src={record?.channelIcon} className="common-table-app-icon" alt="" />
      <span style={{ lineHeight: '24px' }}>{value}</span>
    </div>
  );
};

export const renderTitle = (value, _i, record) => {
  return (
    <div>
      <div style={{ display: 'flex' }}>
        {value?.iconPublicUrl ? (
          <img src={value?.iconPublicUrl} className="common-table-app-icon" alt="" />
        ) : (
          <DefaultAppIcon className="common-table-app-icon" />
        )}
        <span>{value?.name}</span>
      </div>
      <div style={{ color: '#B4BACC', marginTop: '5px' }}>{value?.appId}</div>
    </div>
  );
};
export const renderId = (value) => {
  return <div className="common-table-app-id">{value}</div>;
};

export const renderStatus = (value) => {
  return <ColorTags {...getMiniAppStatus(value)} />;
};

export const renderCreator = (value) => {
  return (
    <>
      {value?.createName}
      <br />
      <span style={{ color: 'rgba(146,152,172,1)' }}>{value?.customerEmail}</span>
    </>
  );
};

export const renderCategory = (value) => {
  return (
    <div>
      {value?.map((i) => (
        <div>{i?.name}</div>
      ))}
    </div>
  );
};
